import React, { useState, useEffect } from 'react';
import Carousel from '../components/home/caroosel_home.js';
import GallerySlider from '../components/home/gallery_home.js';



function Home() {
    return (
        <main>
            <Carousel />
            <GallerySlider />

        </main>

    );
}

export default Home;

